// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { useForm } from 'react-hook-form';
import ActionBar from '../../layout/ActionBar';
import TerritoryForm from './components/TerritoryForm';
import DeleteTerritory from './slideout/DeleteTerritory';
import {
  saveTerritory,
  getTerritoryById,
  getStats,
} from '../../../actions/territoryActions';
import Loading from '../../common/Loading';
import SlidingPane from 'react-sliding-pane';
import { useTranslation } from 'react-i18next';
import Button from '../../common/Button';
import ResponsiveActionBarButtons from '../../common/ResponsiveActionBarButtons';
import { usePageTitle } from '../../../util/pageTitle';
import { useNavigate, useParams } from 'react-router-dom';
import TerritoryStats from './components/TerritoryStats';

function Territory({ saveTerritory }) {
  const { id } = useParams();
  const [pageTitle, setPageTitle] = usePageTitle(['Territories', 'Settings']);
  const [stats, setStats] = useState();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
  } = useForm();

  const onSubmit = (data) => {
    saveTerritory({ ...territory, ...data })
      .then(() => {
        setTerritory({ ...territory, ...data });
        toast.success(t('Territory saved'));
      })
      .catch(() => {
        toast.error(t('Failed to save territory'));
      });
  };

  const [deleteSlideoutOpen, setDeleteSlideoutOpen] = useState(false);
  const handleDelete = (e) => {
    e.cancelBubble = true;
    setDeleteSlideoutOpen(true);
    return false;
  };

  const [territory, setTerritory] = useState({});

  useEffect(() => {
    if (id) {
      getTerritoryById(id)
        .then((d) => {
          setTerritory(d);
        })
        .catch((e) => {
          console.error(e);
          navigate('/settings/territories/');
          toast.error(t('Territory not found'));
        });

      getStats(id)
        .then((d) => {
          setStats(d);
        })
        .catch((e) => {
          toast.error(e.message || t('Failed to get stats'));
        });
    }
  }, [id, t, navigate]);

  return territory ? (
    <>
      <ActionBar
        breadcrumb={[
          { link: '/settings/territories', label: t('Territories') },
          { label: territory.name },
        ]}
      >
        <div className="d-flex">
          <ResponsiveActionBarButtons
            buttons={[
              id && (
                <Button
                  className="btn btn-danger ms-2 d-none d-md-inline-flex"
                  onClick={handleDelete}
                  text={t('Delete')}
                />
              ),
              <Button
                key="save"
                className="btn btn-primary ms-2"
                onClick={handleSubmit(onSubmit)}
                text={t('Save')}
              />,
            ]}
          />
        </div>
      </ActionBar>
      <TerritoryStats
        id={territory.id}
        stats={stats}
        getData={() => getStats(territory.id)}
      />

      <TerritoryForm
        territory={territory}
        register={register}
        errors={errors}
        control={control}
      />

      <SlidingPane
        isOpen={deleteSlideoutOpen}
        hideHeader={true}
        from="right"
        className="small-side-panel"
        onRequestClose={() => setDeleteSlideoutOpen(false)}
      >
        <DeleteTerritory
          id={id}
          done={(d) => {
            setDeleteSlideoutOpen(false);
            navigate('/settings/territories/');
          }}
          cancel={() => setDeleteSlideoutOpen(false)}
        />
      </SlidingPane>
    </>
  ) : (
    <Loading></Loading>
  );
}

const mapDispatchToProps = {
  saveTerritory,
};



export default connect(null, mapDispatchToProps)(Territory);
